/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Continue_With_GoogleInputs */

const fr_auth_continue_with_google = /** @type {(inputs: Auth_Continue_With_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuer avec Google`)
};

const en_auth_continue_with_google = /** @type {(inputs: Auth_Continue_With_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue with Google`)
};

/**
* | output |
* | --- |
* | "Continue with Google" |
*
* @param {Auth_Continue_With_GoogleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_continue_with_google = /** @type {((inputs?: Auth_Continue_With_GoogleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Continue_With_GoogleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_continue_with_google(inputs)
	return fr_auth_continue_with_google(inputs)
});